var spinnerStyleIdentifiers = [
    '.spk-load-container',
    '.spinner-loading',
    '.loading-bar-container',
    '.pan-loading-indicator',
    '.loading-spinner',
    '.ant-skeleton-active',
    '#nprogress',
    '[data-cy="loading"]',
    '[data-testid="netsec-ui-chart-loading"]',
    '[data-testid="Loading Panel"]',
    '[aria-label="Loading"]',
    '[id*="CircularProgress"]',
    '[class*="CircularProgress"]'
].join(',');
var RumSDK = /** @class */ (function () {
    function RumSDK() {
        this.timeoutId = null;
        this.activeInterval = null;
        this.viewMap = undefined;
        if (RumSDK.instance) {
            return RumSDK.instance;
        }
        this.timeoutId = null;
        this.activeInterval = null;
        this.viewMap = new Map();
    }
    RumSDK.getInstance = function () {
        if (!RumSDK.instance) {
            RumSDK.instance = new RumSDK();
        }
        return RumSDK.instance;
    };
    RumSDK.prototype.cancelTelemetryInterval = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        if (this.activeInterval) {
            clearInterval(this.activeInterval);
            this.activeInterval = null;
        }
    };
    RumSDK.prototype.pollLoadingTimeTelemetry = function (viewId) {
        var _this = this;
        if (viewId === void 0) { viewId = window.location.pathname; }
        this.cancelTelemetryInterval();
        // check view for spinning loaders every 100ms
        // if none are present, record as page render completed
        this.timeoutId = setTimeout(function () {
            _this.activeInterval = setInterval(function () {
                try {
                    var loadingElements = document.querySelectorAll(spinnerStyleIdentifiers);
                    if (loadingElements.length === 0) {
                        _this.cancelTelemetryInterval();
                        _this.stopView(viewId);
                    }
                }
                catch (err) {
                    console.log('Error query for loading elements');
                }
            }, 100);
        }, 200);
    };
    RumSDK.prototype.startView = function (viewId) {
        var _a;
        if (viewId === void 0) { viewId = window.location.pathname; }
        var startTime = performance.now();
        (_a = this.viewMap) === null || _a === void 0 ? void 0 : _a.set(viewId, { startTime: startTime });
    };
    RumSDK.prototype.stopView = function (viewId) {
        var _a, _b;
        if (viewId === void 0) { viewId = window.location.pathname; }
        var endTime = performance.now();
        var viewData = (_a = this.viewMap) === null || _a === void 0 ? void 0 : _a.get(viewId);
        if (viewData && viewData.startTime) {
            var duration = endTime - viewData.startTime;
            (_b = this.viewMap) === null || _b === void 0 ? void 0 : _b.delete(viewId);
            this.addDDTiming(duration);
            console.log("View ".concat(viewId, "  started at ").concat(viewData.startTime, " stopped at ").concat(endTime, ", duration: ").concat(duration, " ms"));
        }
        else {
            console.warn("No start time recorded for view ".concat(viewId));
        }
    };
    RumSDK.prototype.measureViewLoadTimeTelemetry = function (viewId) {
        if (viewId === void 0) { viewId = window.location.pathname; }
        this.startView(viewId);
        // start polling for end of loading time
        this.pollLoadingTimeTelemetry(viewId);
    };
    RumSDK.prototype.addDDTiming = function (timing) {
        if (timing === void 0) { timing = performance.now(); }
        // Ensure that Datadog RUM is initialized and available
        if (window.DD_RUM) {
            window.DD_RUM.addTiming('scm_loading_time', timing);
        }
        else {
            console.error('Datadog RUM is not initialized.');
        }
    };
    RumSDK.instance = null;
    return RumSDK;
}());
export default RumSDK;
